import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Slider,
  Row,
  Col,
  Typography,
  Image,
  Input,
  DatePicker,
  Radio,
  Tag,
  message,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";

import Title from "antd/es/typography/Title";
import RFPImage from "../../../assests/RFP-Image.png";
import FloatingInput from "../../common/float-input/FloatInput";
import "./RfpRequestModal.css";
import "../../common/bill-board/AddBillBoard.css";
import CalendarComponent from "../../common/calendar/CalendarComponent";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { searchCities } from "../../../store/thunks/authThunk";
import { searchLocation } from "../../../store/thunks/authThunk";
import { debounce } from "lodash";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import { ReactComponent as DeleteIcon } from "../../../assests/delete_icon.svg";
import { ReactComponent as CalenderIcon } from "../../../assests/Mobile_calender_Icon.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  getChannelsBeforeLogin,
  postSubmitRFP,
  postSubmitRFPWithLogin,
} from "../../../store/thunks/common-thunks/commonThunk";
import { getChannelsFromProductType } from "../../../store/thunks/seller-thunks/SellerThunk";
import enUS from "antd/es/date-picker/locale/en_US";
import { RESET_RFP } from "../../../store/slices/auth/SubmitRFPSlice";
import moment from "moment-timezone";
import { PDF_BASE_URL } from "../../../services/common";
import {
  allowOnlyAlphabets,
  blockPasteInvalid,
  restrictNumbersAndExponential,
} from "../../common/utils/Utils";
dayjs.extend(utc);

const { Text } = Typography;
const RFPModal = ({
  RFP,
  setRFP,
  isLoggedIn,
  form,
  selectedTransferProducts,
  setSelectedTransferProducts,
}) => {
  const token = localStorage.getItem("token");
  const [sliderValue, setSliderValue] = useState([0, 1000000]);
  const [dateRanges, setDateRanges] = useState([]);
  const [dmaList, setDmaList] = useState([
    { id: 1, fromDate: null, toDate: null },
  ]);
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const restrictions = [
    { id: "alcohol", name: "Alcohol-Restricted" },

    {
      id: "adult-content",
      name: "Adult Content Restricted",
    },
    {
      id: "tobacco-smoking",
      name: "Tobacco & Smoking Ads Restricted",
    },
    {
      id: "cannabis-pharma",
      name: "Cannabis/Pharma Restricted",
    },
    {
      id: "gambling-betting",
      name: "Gambling/Betting Restricted",
    },
    {
      id: "religious-content",
      name: "Religious Content Restricted",
    },
    {
      id: "violence-horror-imagery",
      name: "Violence/Horror imagery Restricted",
    },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const [dmaLocations, setDmaLocations] = useState([]);
  const dispatch = useDispatch();
  const dmaCache = useRef(null);
  const {
    locationDma,
    isLoading: locationLoader,
    citiesList,
  } = useSelector((state) => state.location);
  const { productChannelsList } = useSelector((state) => state.products);
  const { isLoading: rfpLoader } = useSelector((state) => state.submitrfp);
  const isLoading = rfpLoader;
  const [inComeSliderValue, SetInComeSliderValue] = useState([0, 1000000]);
  const [specificCreative, SetSpecificCreative] = useState("true");
  const [specificMessage, SetSpecificMessage] = useState("true");
  const [callAction, SetCallAction] = useState("true");
  const [productAnimation, SetProductAnimation] = useState("true");
  const [dueDate, setDueDate] = useState("");
  const [selectedDates, SetSelectedDates] = useState("");
  const [productTypeList, setProductTypeList] = useState([]);
  const [selectedEthnicity, setSelectedEthnicity] = useState("");
  const [selectedProductType, setSelectedProductType] = useState("");
  const [selectedDMALocations, setSelectedDMALocations] = useState({});
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  const handleInComeSliderChange = (value) => {
    SetInComeSliderValue(value);
  };
  const formatDateRange = (dates, index) => {
    if (!Array.isArray(dates) || dates.length !== 2) {
      return;
    }

    const fromDate = dayjs
      .utc()
      .set("year", dates[0].year())
      .set("month", dates[0].month())
      .set("date", dates[0].date())
      .startOf("day")
      .toISOString();
    const toDate = dayjs
      .utc()
      .set("year", dates[1].year())
      .set("month", dates[1].month())
      .set("date", dates[1].date())
      .startOf("day")
      .toISOString();

    setDateRanges((prevRanges) => {
      const updatedRanges = [...prevRanges];

      if (index < updatedRanges.length) {
        updatedRanges[index] = `${fromDate}::${toDate}`;
      } else {
        updatedRanges.push(`${fromDate}::${toDate}`);
      }

      return updatedRanges;
    });
  };

  const handleDateRangeChange = (index, dates, dmaId, newRange) => {
    const formattedRange = formatDateRange(index);
    SetSelectedDates(dates);
  };

  const handleInputChange = (index, e) => {
    let newValue = [...sliderValue];
    const numericVal = Number(e.target.value) || 0; // Convert input to number
    newValue[index] = numericVal;
    setSliderValue(newValue);
    if (index === 0) {
      form.setFieldsValue({ est_budget_from: numericVal });
    } else {
      form.setFieldsValue({ est_budget_to: numericVal });
    }
  };
  const handleIncomeInputChange = (index, e) => {
    let newValue = [...inComeSliderValue];
    newValue[index] = Number(e.target.value) || 0;
    SetInComeSliderValue(newValue);
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day"); // Disable past dates
  };
  // Debounced search function
  const handleSearch = useCallback(
    debounce((value) => {
      if (!value.trim()) {
        setDmaLocations([]);
        return;
      }

      dispatch(searchLocation(value.trim()));
    }, 300),
    [dispatch],
  );

  // Handle selection change
  const handleChange = (value, dmaId) => {
    setSearchTerm(value || "");
    setSelectedDMALocations((prev) => ({
      ...prev,
      [dmaId]: value,
    }));
    form.setFieldValue(`dma-${dmaId}`, value);
  };
  const brandGoal = Form.useWatch("brand_goal", form);
  // Restore cached options if available
  useEffect(() => {
    if (dmaCache.current) {
      setDmaLocations(dmaCache.current.payload);
    }
  }, [dmaCache.current]);
  // Update DMA locations when locationDma changes
  useEffect(() => {
    if (locationDma?.length) {
      const formattedLocations = locationDma?.map((location) => ({
        label: `${location.city_name} - ${location.name}`,
        value: location.id,
        state: location.state_name,
        timeZone: location.area_time_zone_type,
        offSet: location.area_time_zone,
      }));
      setDmaLocations(formattedLocations);
    }
  }, [locationDma]);

  useEffect(() => {
    if (token) {
      dispatch(getChannelsFromProductType({ type: [] }));
    } else {
      dispatch(getChannelsBeforeLogin({ type: [] }));
    }
  }, []);

  const handleProductTypes = (value) => {
    form.setFieldsValue({ type: null });
    const selectedChannel = productChannelsList?.find(
      (product) => product?.id === value,
    );
    if (selectedChannel) {
      const mapping = {
        Digital: "Digital",
        "Digital/Static": "Digital/Static",
        Media: "Media",
        Static: "Static",
      };
      const productTypeList = Object.entries(mapping)
        .filter(([key]) => selectedChannel[key] === 1)
        ?.map(([, label]) => label);
      setProductTypeList(productTypeList);
    }
  };

  const handleAddDma = () => {
    setDmaList([
      ...dmaList,
      { id: dmaList.length + 1, fromDate: null, toDate: null },
    ]);
  };
  const handleDeleteDMA = (id) => {
    setDmaList((prevList) => prevList.filter((dma) => dma.id !== id));
    setSelectedDMALocations((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
    form.resetFields([`dma-${id}`, "date_ranges"]);
  };
  const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp * 1000 > Date.now(); // true if token is still valid
    } catch (e) {
      return false;
    }
  };
  const handleSubmit = async (values) => {
    const utmSource = localStorage.getItem("utm_source");
    const dmaKeys = Object.keys(values).filter((key) => key.startsWith("dma-"));
    const dmaValues = dmaKeys?.map((key) => values[key]);
    const toArray = (val) => (Array.isArray(val) ? val : [val]);
    const tokenIsValid = isTokenValid();
    const payload = {
      dma_city: dmaValues,
      date_ranges: dateRanges,
      due_date: dueDate,
      first_name: values.first_name,
      last_name: values.last_name,
      user_email: values.user_email,
      mobile_no: values.mobile_no,
      producttype: toArray(values.producttype),
      campaign_name: values.campaign_name,
      demo: values.demo,
      instructions: values.instructions || "Test",
      est_budget_from: sliderValue[0]?.toString(),
      est_budget_to: sliderValue[1]?.toString(),
      budget: sliderValue[1]?.toString(),
      brand_goal: toArray(
        values.brand_goal === "Others"
          ? values.brand_goal_other
          : values.brand_goal,
      ),
      business_goal: toArray(values.business_goal),
      format_type: toArray(values.format_type),
      desired_medium: toArray(values.desiredMedium),
      target_consumer: values.targetConsumer,
      age: values.age,
      marketing_funnel: values.marketing_funnel,
      income_from: inComeSliderValue[0]?.toString(),
      income_to: inComeSliderValue[1]?.toString(),
      ethnicity: toArray(
        values.ethnicity === "other" && values.others
          ? values.others
          : values.ethnicity,
      ),
      restrictions: toArray(selectedTransferProducts),
      creative_to_run: specificCreative,
      specific_message: specificMessage,
      call_to_action: callAction,
      product_animation: productAnimation,
      ...(utmSource && {
        utm_source: utmSource,
      }),
    };
    if (!tokenIsValid) {
      payload.first_name = values.first_name;
      payload.last_name = values.last_name;
      payload.user_email = values.user_email;
      payload.mobile_no = values.mobile_no;
    }
    const submitAction = tokenIsValid ? postSubmitRFPWithLogin : postSubmitRFP; // condition based dispatch api
    dispatch(submitAction(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(res?.payload?.message);
        form.resetFields();
        SetInComeSliderValue([5000, 40000]);
        setSliderValue([5000, 40000]);
        setDmaList([{ id: 1 }]);
        setSelectedDMALocations({});
        setDueDate("");
        setDateRanges([]);
        setSearchTerm("");
        setSelectedTransferProducts([]);
        SetSpecificCreative("true");
        SetSpecificMessage("true");
        SetCallAction("true");
        SetProductAnimation("true");
        setRFP(false);
        dispatch(RESET_RFP());
      } else {
        message.error(res?.payload?.message || "Something went wrong", 5);
        dispatch(RESET_RFP());
        setDateRanges([]);
      }
    });
  };
  const formValues = Form.useWatch([], form);

  const isSubmitDisabled = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const commonRequiredFields = [
      "campaign_name",
      "format_type",
      "producttype",
      "age",
      "marketing_funnel",
      "due_date",
      ...dmaList?.map((dma) => `dma-${dma?.id}`),
    ];

    const requiredFields = isTokenValid()
      ? commonRequiredFields
      : [
          "first_name",
          "last_name",
          "user_email",
          "mobile_no",
          ...commonRequiredFields,
        ];

    return (
      hasErrors ||
      requiredFields?.some((field) => {
        const value = form?.getFieldValue(field);
        return (
          value === undefined ||
          value === null ||
          value === "" ||
          (Array?.isArray(value) && value?.length === 0)
        );
      })
    );
  };
  return (
    <>
      <div className="rfp-form-modal-container">
        <div className="main-rfp-request-padding">
          <Row>
            <Col span={12} offset={10}>
              <Title className="submit-rfp-main-heading">Submit Your RFP</Title>
            </Col>
          </Row>
          <Row className="rfp-image-row">
            <Col span={11} className="rfp-main-image">
              <Image
                src={RFPImage}
                alt=""
                width={490}
                height={550}
                preview={false}
              ></Image>
            </Col>
            <Col span={12}>
              <div className="customer-details-of-rfp-row">
                <Form layout="vertical" onFinish={handleSubmit} form={form}>
                  {!isTokenValid() ? (
                    <>
                      <Row className="coustomer-title-row">
                        <Text className="common-text-for-all">CUSTOMER</Text>
                      </Row>
                      <Row gutter={[16, 16]} className="class-row-margin-top">
                        <Col span={12}>
                          <Form.Item
                            name="first_name"
                            rules={[
                              {
                                required: true,
                                message: "Please input your First Name",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`First Name `}
                                  {star}
                                </>
                              }
                              onKeyDown={restrictNumbersAndExponential}
                              onChange={allowOnlyAlphabets}
                              onPaste={blockPasteInvalid}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="last_name"
                            rules={[
                              {
                                required: true,
                                message: "Please input your Last Name",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Last Name `}
                                  {star}
                                </>
                              }
                              onKeyDown={restrictNumbersAndExponential}
                              onChange={allowOnlyAlphabets}
                              onPaste={blockPasteInvalid}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <Form.Item
                            name="campaign_name"
                            rules={[
                              {
                                required: true,
                                message: "Campaign Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Campaign Name `}
                                  {star}
                                </>
                              }
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={12}>
                          <Form.Item
                            name="user_email"
                            rules={[
                              {
                                type: "email",
                                required: true,
                                message: "Email is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Email `}
                                  {star}
                                </>
                              }
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <Form.Item
                            name="mobile_no"
                            rules={[
                              {
                                required: true,
                                message: "Phone Number is required!",
                              },
                              {
                                pattern: /^\d{10}$/,
                                message:
                                  "Phone number must be exactly 10 digits",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Phone Number `}
                                  {star}
                                </>
                              }
                              maxLength={10}
                              onKeyPress={(e) => {
                                if (!/^\d$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className="coustomer-title-row">
                        <Text className="common-text-for-all">
                          CAMPAIGN DETAILS
                        </Text>
                      </Row>
                      <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
                        <Col span={12}>
                          <Form.Item
                            name="campaign_name"
                            rules={[
                              {
                                required: true,
                                message: "Campaign Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={<>Campaign Name {star}</>}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Text className="common-text-for-all">
                      BUSINESS & MARKETING GOALS
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} className="coustomer-title-row">
                    <Col span={12}>
                      <Form.Item name="brand_goal">
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={<>{`Brand Goal `}</>}
                          options={[
                            { id: "brand-exposure", name: "Brand Exposure" },
                            {
                              id: "sample/trial-product",
                              name: "Sample/trial Product",
                            },
                            { id: "generate-leads", name: "Generate Leads" },
                            {
                              id: "social-media-following",
                              name: "Increase Social media following",
                            },
                            {
                              id: "kpit-measurement",
                              name: "KPI Measurements",
                            },
                            {
                              id: "others",
                              name: "Others",
                            },
                          ]}
                          customStyles={floatingSelectStyles}
                          onChange={(value) => {
                            if (value !== "Others") {
                              form.setFieldsValue({
                                brand_goal_other: undefined,
                              });
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      {brandGoal === "Others" ? (
                        <Form.Item
                          name="brand_goal_other"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Brand Goal",
                            },
                          ]}
                        >
                          <FloatingInput
                            className="billboard-input-feild"
                            label={
                              <>
                                {`Brand Goal - Others `}
                                {star}
                              </>
                            }
                            customStyles={floatingInputStyles}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item name="business_goal">
                          <FloatingSelect
                            className="billboard-select-feild"
                            border={false}
                            label={<>{`Business/Commercial Goals`}</>}
                            options={[
                              {
                                id: "rfp-input-field",
                                name: "More Subscribers",
                              },
                              {
                                id: "buy-new-product-at-retail",
                                name: "Buy new product at retail",
                              },
                              {
                                id: "convert-store-shopper-to-home-subscription-model",
                                name: "Convert store shopper to home subscription model",
                              },
                            ]}
                            customStyles={floatingSelectStyles}
                          />
                        </Form.Item>
                      )}
                    </Col>

                    {brandGoal === "Others" && (
                      <Col span={12}>
                        <Form.Item name="business_goal">
                          <FloatingSelect
                            className="billboard-select-feild"
                            border={false}
                            label="Business/Commercial Goals"
                            options={[
                              {
                                id: "rfp-input-field",
                                name: "More Subscribers",
                              },
                              {
                                id: "buy-new-product-at-retail",
                                name: "Buy new product at retail",
                              },
                              {
                                id: "convert-store-shopper-to-home-subscription-model",
                                name: "Convert store shopper to home subscription model",
                              },
                            ]}
                            customStyles={floatingSelectStyles}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Text className="common-text-for-all">
                      TIMING & LOCATION
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} className="coustomer-title-row">
                    <Col span={12}>
                      <Form.Item
                        name="format_type"
                        rules={[
                          {
                            required: true,
                            message: "Product Type is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={
                            <>
                              {`Product Type`}
                              {star}
                            </>
                          }
                          value={selectedProductType}
                          isChannels={true}
                          options={productChannelsList?.map((channel) => ({
                            id: channel.id,
                            name: `${channel?.channel_name} - ${channel?.sub_channel_name}`,
                          }))}
                          onChange={(_e, value) => {
                            setSelectedProductType(null);
                            handleProductTypes(value?.value);
                          }}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="producttype"
                        rules={[
                          {
                            required: true,
                            message: "Format is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={
                            <>
                              {`Format `}
                              {star}
                            </>
                          }
                          options={productTypeList?.map((type, index) => ({
                            id: index,
                            name: type,
                          }))}
                          customStyles={floatingSelectStyles}
                          onChange={(_e, value) => {
                            setSelectedProductType(value?.key);
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Row className="dma-selection-row">
                      {dmaList?.map((dma, index) => {
                        const isDMALocationSelected = Boolean(
                          dmaLocations?.find(
                            (loc) => loc?.value === searchTerm,
                          ),
                        );

                        return (
                          <Row key={dma?.id} className="dma-calender-row-rfp">
                            <Col style={{ width: "48%" }}>
                              <Form.Item
                                name={`dma-${dma?.id}`}
                                style={{ paddingRight: 10 }}
                                rules={[
                                  {
                                    required: true,
                                    message: `Dma is required!`,
                                  },
                                ]}
                              >
                                <FloatingSelect
                                  showSearch
                                  //filterOption={false}
                                  allowClear
                                  className="billboard-select-feild"
                                  label={
                                    <>
                                      {`DMA `}
                                      {star}
                                    </>
                                  }
                                  value={
                                    searchTerm ||
                                    selectedDMALocations[dma?.id] ||
                                    ""
                                  }
                                  onChange={(value) =>
                                    handleChange(value, dma?.id)
                                  }
                                  onSearch={handleSearch} // Debounced API call
                                  loading={locationLoader} // Show spinner if request is in progress
                                  options={dmaLocations}
                                  isDma={true}
                                  optionFilterProp="label"
                                  filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      )
                                  }
                                  customStyles={floatingSelectStyles}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              style={{
                                width: index !== 0 ? "40%" : "48%",
                                justifyContent: "space-between",
                              }}
                              className={` ${
                                !form?.getFieldValue(`dma-${dma?.id}`)
                                  ? "disabled-opacity"
                                  : ""
                              }`}
                            >
                              <Form.Item
                                className="rfp-input-field"
                                name="date_ranges"
                                style={{ paddingTop: 20 }}
                              >
                                <div className="rfp-dma-calendar-div">
                                  <CalendarComponent
                                    open={true}
                                    popupClassName="custom-calendar-rfp-dropdown"
                                    className="rfp-calendar-component-design"
                                    disabled={
                                      !searchTerm?.length ||
                                      !selectedDMALocations[dma?.id]
                                    }
                                    onDateRangeChange={handleDateRangeChange}
                                    disabledDate={(current) => {
                                      const dma = dmaLocations?.find(
                                        (location) =>
                                          location.value ===
                                          form?.getFieldValue(`dma-${dma.id}`),
                                      );
                                      const nowUTC = moment().utc();
                                      const nowInSelectedTZ = nowUTC
                                        .tz(dma?.timeZone)
                                        ?.startOf("day");
                                      return (
                                        current &&
                                        current?.isBefore(
                                          nowInSelectedTZ,
                                          "day",
                                        )
                                      );
                                    }}
                                  />
                                </div>
                              </Form.Item>
                            </Col>
                            {index !== 0 && (
                              <Col style={{ width: "5%" }}>
                                <DeleteIcon
                                  style={{ color: "#d2042d" }}
                                  onClick={() => handleDeleteDMA(dma.id)}
                                  className="rfp-delete-icon-dma"
                                />
                              </Col>
                            )}
                          </Row>
                        );
                      })}
                    </Row>
                    <Col span={12}>
                      <a
                        href={`${PDF_BASE_URL}/DMA%20-%20PDF.pdf`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-dma-map-pdf-rfp"
                      >
                        View DMA Map (PDF)
                      </a>
                    </Col>

                    <Col span={12}>
                      <div className="rfp-request-div-css">
                        <Button
                          className="handle-dma-btn-rfp"
                          onClick={handleAddDma}
                        >
                          <PlusOutlined />
                          Add New DMA
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="budget-row-rfp">
                    <Text className="common-text-for-all">BUDGET</Text>
                  </Row>
                  <Row className="budget-row-rfp">
                    <Text className="rfp-budget-range-text">Budget Range</Text>
                  </Row>
                  <Row className="budget-input" gutter={[16, 16]}>
                    <Col span={12}>
                      <Form.Item name="est_budget_from">
                        <Row>
                          <span className="rfp-request-row-css">From</span>
                        </Row>
                        <Row>
                          <Input
                            className="rfp-input-field"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={sliderValue[0]}
                            onChange={(e) => handleInputChange(0, e)}
                            variant="underlined"
                            prefix="$"
                          />
                        </Row>
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item name="est_budget_to">
                        <Row>
                          <span className="rfp-to-input">To</span>
                        </Row>
                        <Row>
                          <Input
                            className="rfp-input-field"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={sliderValue[1]}
                            onChange={(e) => handleInputChange(1, e)}
                            variant="underlined"
                            prefix="$"
                          />
                        </Row>
                      </Form.Item>
                    </Col>
                  </Row>

                  <div className="slider-parent">
                    <Slider
                      range
                      value={sliderValue}
                      min={0}
                      max={1000000}
                      trackStyle={{ backgroundColor: "red" }}
                      tooltip={{ open: false }}
                      onChange={handleSliderChange}
                      className="rfp-modal-slider-view"
                    />
                  </div>
                  <Row style={{ marginTop: "2rem" }}>
                    <Text className="common-text-for-all">
                      TARGET & DEMOGRAPHICS
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} className="submit-rfp-button-row">
                    <Col span={12}>
                      <Form.Item
                        name="age"
                        rules={[
                          {
                            required: true,
                            message: "Age is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={
                            <>
                              {`Age`}
                              {star}
                            </>
                          }
                          options={[
                            { id: "18-49", name: "18-49" },

                            {
                              id: "cmpa- 18-plus",
                              name: "A 18-49",
                            },
                            {
                              id: "18-plus",
                              name: "18-Plus",
                            },
                            {
                              id: "cpma-18-plus",
                              name: "A 18-Plus",
                            },
                            {
                              id: "25-54",
                              name: "25-54",
                            },
                            {
                              id: "cpma-25-54",
                              name: "A 25-54",
                            },
                          ]}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="marketing_funnel"
                        rules={[
                          {
                            required: true,
                            message: "Marketing-Funnels is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={
                            <>
                              {`Marketing Funnel`}
                              {star}
                            </>
                          }
                          options={[
                            { id: "awareness", name: "Awareness" },

                            {
                              id: "interest",
                              name: "Interest",
                            },
                            {
                              id: "consideration",
                              name: "Consideration",
                            },
                            {
                              id: "intent",
                              name: "Intent",
                            },
                            {
                              id: "evaluation",
                              name: "Evaluation",
                            },
                            {
                              id: "purchase",
                              name: "Purchase",
                            },
                            {
                              id: "post-purchase-loyalty",
                              name: "Post-Purchase / Loyalty",
                            },
                          ]}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Text className="rfp-budget-range-text">Income Range</Text>
                  </Row>
                  <Row className="budget-input" gutter={[16, 16]}>
                    <Col span={12}>
                      <Form.Item name="income_from">
                        <Row>
                          <span className="rfp-to-input ">From</span>
                        </Row>
                        <Row>
                          <Input
                            className="rfp-input-field"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={inComeSliderValue[0]}
                            onChange={(e) => handleIncomeInputChange(0, e)}
                            variant="underlined"
                            prefix="$"
                          />
                        </Row>
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item name="income_to">
                        <Row>
                          <span className="rfp-to-input ">To</span>
                        </Row>
                        <Row>
                          <Input
                            className="rfp-input-field"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={inComeSliderValue[1]}
                            onChange={(e) => handleIncomeInputChange(1, e)}
                            variant="underlined"
                            prefix="$"
                          />
                        </Row>
                      </Form.Item>
                    </Col>
                  </Row>
                  <div className="slider-parent">
                    <Slider
                      range
                      value={inComeSliderValue}
                      min={0}
                      max={1000000}
                      trackStyle={{ backgroundColor: "red" }}
                      tooltip={{ open: false }}
                      onChange={handleInComeSliderChange}
                    />
                  </div>
                  <Row gutter={[16, 16]} style={{ marginTop: "1.5rem" }}>
                    <Col span={12}>
                      <Form.Item name="ethnicity">
                        <FloatingSelect
                          className="billboard-select-feild"
                          border={false}
                          label={<>{`Ethnicity`}</>}
                          options={[
                            { id: "caucasian", name: "Caucasian" },

                            {
                              id: "hispanic",
                              name: "Hispanic",
                            },
                            {
                              id: "af-american",
                              name: "Af American/Digital",
                            },
                            {
                              id: "Asian",
                              name: "Asian",
                            },
                            { id: "native-am", name: "Native Am " },
                            { id: "other", name: "Other" },
                          ]}
                          onChange={(value) => {
                            setSelectedEthnicity(value);
                          }}
                          value={selectedEthnicity}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Col>
                    {selectedEthnicity === "Other" && (
                      <Col span={12}>
                        <Form.Item
                          name="others"
                          rules={[
                            {
                              type: "ethnicity-other",
                              required: true,
                              message: "Ehtnicity is required!",
                            },
                          ]}
                        >
                          <FloatingInput
                            className="billboard-input-feild"
                            label={
                              <>
                                {`Others (Specify)`}
                                {star}
                              </>
                            }
                            customStyles={floatingInputStyles}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Row className="budget-row-rfp">
                    <Text className="common-text-for-all">RESTRICTIONS</Text>
                  </Row>
                  <Row gutter={[16, 16]} className="submit-rfp-button-row">
                    <Col span={12}>
                      <Form.Item name="restrictions">
                        <div className="restrictions-col">
                          <FloatingSelect
                            value={selectedTransferProducts}
                            mode="multiple"
                            className="billboard-select-feild transfer-product"
                            border={false}
                            isMultipleProduct={true}
                            label={<>{`Restrictions`}</>}
                            options={restrictions}
                            onChange={(_e, values) => {
                              const selectedValues = values?.map(
                                (item) => item.value,
                              );
                              setSelectedTransferProducts(selectedValues);
                            }}
                            popupClassName="transfer-product"
                            customStyles={floatingSelectStyles}
                            tagRender={() => <></>}
                          />
                        </div>
                      </Form.Item>
                    </Col>

                    <Col></Col>
                  </Row>
                  <div className="selected-vals">
                    {selectedTransferProducts &&
                      selectedTransferProducts.length > 0 &&
                      selectedTransferProducts?.map((transferProduct) => (
                        <Tag
                          key={transferProduct}
                          className="transfer-product-chip"
                          closable
                          onClose={(e) => {
                            e.preventDefault();
                            setSelectedTransferProducts(
                              selectedTransferProducts.filter(
                                (chip) => chip !== transferProduct,
                              ),
                            );
                          }}
                        >
                          <span>
                            {
                              restrictions?.find(
                                (product) => product?.id === transferProduct,
                              )?.name
                            }
                          </span>
                        </Tag>
                      ))}
                  </div>
                  <Row style={{ marginTop: "2rem" }}>
                    <Text className="common-text-for-all">
                      OTHER INSTRUCTIONS
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} className="rfp-request-actions-row">
                    <Col span={12}>
                      <Row>
                        <Text className="rfp-other-instructions-text">
                          Do you have specific creative to run?
                        </Text>
                      </Row>
                      <Row style={{ marginTop: "15px" }}>
                        <Col>
                          <Radio.Group
                            onChange={(e) => {
                              SetSpecificCreative(e.target.value);
                            }}
                            value={specificCreative}
                          >
                            <Radio value={"true"}>Yes</Radio>
                            <Radio value={"false"}>No</Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Text className="rfp-other-instructions-text">
                          Specific Message
                        </Text>
                      </Row>
                      <Row style={{ marginTop: "15px" }}>
                        <Col>
                          <Radio.Group
                            onChange={(e) => {
                              SetSpecificMessage(e.target.value);
                            }}
                            value={specificMessage}
                          >
                            <Radio value={"true"}>Yes</Radio>
                            <Radio value={"false"}>No</Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Text className="rfp-other-instructions-text">
                          Call to Action
                        </Text>
                      </Row>
                      <Row style={{ marginTop: "15px" }}>
                        <Col>
                          <Radio.Group
                            onChange={(e) => {
                              SetCallAction(e.target.value);
                            }}
                            value={callAction}
                          >
                            <Radio value={"true"}>Yes</Radio>
                            <Radio value={"false"}>No</Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Text className="rfp-other-instructions-text">
                          Product Animation
                        </Text>
                      </Row>
                      <Row style={{ marginTop: "15px" }}>
                        <Col>
                          <Radio.Group
                            onChange={(e) => {
                              SetProductAnimation(e.target.value);
                            }}
                            value={productAnimation}
                          >
                            <Radio value={"true"}>Yes</Radio>
                            <Radio value={"false"}>No</Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="budget-row-rfp">
                    <Col span={12}>
                      <Form.Item
                        name="due_date"
                        rules={[
                          {
                            required: true,
                            message: "Due Date is required!",
                          },
                        ]}
                        className="rfp-request-dates-item"
                      >
                        <DatePicker
                          placeholder={"* Due Date"}
                          locale={customLocale}
                          className="billboard-datepicker"
                          suffixIcon={<CalenderIcon />}
                          disabledDate={disabledDate}
                          onChange={(date, datestring) => {
                            if (date) {
                              setDueDate(
                                dayjs
                                  .utc()
                                  .set("year", date?.year())
                                  .set("month", date?.month())
                                  .set("date", date?.date())
                                  .startOf("day")
                                  .toISOString(),
                              );
                            } else {
                              setDueDate(null);
                            }
                          }}
                          superNextIcon={false}
                          superPrevIcon={false}
                          popupClassName="end-date-calendar"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                  <Row className="submit-rfp-button-row">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className={`rfp-request-submit-button-css billboard-button-2 ${
                        isSubmitDisabled() ? "disabled-opacity" : ""
                      }`}
                      id="submit_an_rfp_btn"
                      disabled={isSubmitDisabled()}
                    >
                      Submit RFP
                    </Button>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
          <div className="rfp-footer-div">
            <Text className="rfp-footer-text">
              Once you submit your RFP, our team will review your details and
              get back to you with a customized proposal within 24-48 hours.
              Thank you for choosing AMP for your advertising needs!
            </Text>
          </div>
        </div>

        {isLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </div>
    </>
  );
};

export default RFPModal;
